import { render, staticRenderFns } from "./VersionView.vue?vue&type=template&id=2977a5f0&"
import script from "./VersionView.vue?vue&type=script&lang=js&"
export * from "./VersionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports